/* eslint-disable default-case */
/* eslint-disable no-case-declarations */
import React from 'react';
import { Typography } from '@material-ui/core';
import CustomToolbar from '../../components/common/CustomToolbar/CustomToolbar';
import _ from './../../utils/lodash';
import { formatNhs } from './../../utils/helpers';

const mapPropName = (columnName, isEntityToDto = false) => {
  const entityNames = [
    'Status',
    'PatientName',
    'PatientAge',
    'PostCode',
    'VisitActivities',
    'VisitBand',
    'VisitMinutes',
    'RetroVisit',
    'PatientNhsNumber',
  ];
  const dtoNames = [
    'status',
    'patientName',
    'age',
    'postcode',
    'activities',
    'band',
    'minutes',
    'retroVisit',
    'nhsNumber',
  ];
  if (isEntityToDto) {
    const index = _.indexOf(entityNames, columnName);
    return dtoNames[index];
  }

  const index = _.indexOf(dtoNames, columnName);
  return entityNames[index];
};

const setSortDirection = (columnDtoName, options) => {
  const entityName = mapPropName(columnDtoName, false);

  return entityName === options.sortColumn ? options.sortDirection : 'none';
};

export const tableSettings = options => {
  const eventHandlers = options.eventHandlers;
  const locale = eventHandlers.locale;

  return {
    name: <Typography variant="h3">{locale.getMsg('pageHeader')}</Typography>,
    columns: [
      {
        name: 'id',
        options: {
          display: 'excluded',
        },
      },
      {
        name: 'isCompleted',
        label: locale.getMsg('status'),
        options: {
          customBodyRender: value => (value ? '✔' : '-'),
          sort: false,
          setCellProps: () => ({ style: { width: '70px' } }),
        },
      },
      {
        name: 'patientName',
        label: locale.getMsg('patientName'),
        options: {
          sort: true,
          sortOrder: {
            name: 'patientName',
            direction: setSortDirection('patientName', options),
          },
        },
      },
      {
        name: 'nhsNumber',
        label: locale.getMsg('nhsNumber'),
        options: {
          sort: true,
          sortOrder: {
            name: 'nhsNumber',
            direction: setSortDirection('nhsNumber', options),
          },
          customBodyRender: value => (value ? formatNhs(value) : '-'),
        },
      },
      {
        name: 'age',
        label: locale.getMsg('age'),
        options: {
          sort: true,
          sortOrder: {
            name: 'age',
            direction: setSortDirection('age', options),
          },
        },
      },
      {
        name: 'postcode',
        label: locale.getMsg('postCode'),
        options: {
          sort: true,
          sortOrder: {
            name: 'postcode',
            direction: setSortDirection('postcode', options),
          },
        },
      },
      {
        name: 'activities',
        label: locale.getMsg('activities'),
        options: {
          sort: true,
          sortOrder: {
            name: 'activities',
            direction: setSortDirection('activities', options),
          },
        },
      },
      {
        name: 'band',
        label: locale.getMsg('band'),
        options: {
          sort: true,
          sortOrder: {
            name: 'band',
            direction: setSortDirection('band', options),
          },
          setCellProps: () => ({ style: { width: '100px' } }),
        },
      },
      {
        name: 'minutes',
        label: locale.getMsg('minutes'),
        options: {
          customBodyRender: value => value || '-',
          sort: true,
          sortOrder: {
            name: 'minutes',
            direction: setSortDirection('minutes', options),
          },
          setCellProps: () => ({ style: { width: '80px' } }),
        },
      },
      {
        name: 'isAddedRetrospectively',
        label: locale.getMsg('retroVisit'),
        options: {
          customBodyRender: value => (value ? '✔' : '-'),
          sort: false,
          setCellProps: () => ({ style: { width: '50px' } }),
        },
      },
    ],
    options: {
      filterType: 'dropdown',
      responsive: 'standard',
      selectableRows: 'none',
      rowsPerPageOptions: [5, 15, 30, 50, 100],
      rowsPerPage: options.pageSize,
      search: false,
      filter: false,
      serverSide: true,
      count: options.count,
      page: options.page,
      customToolbar: () => (
        <CustomToolbar eventHandlers={options.eventHandlers} isTableDataLoading={options.isTableDataLoading} />
      ),
      onRowClick: rowData => options.eventHandlers.go(`/VisitActuals/${rowData[0]}`),
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
          case 'changeRowsPerPage':
            options.eventHandlers.updateTableProps(tableState.page + 1, tableState.rowsPerPage);
            break;
          case 'sort':
            let sortColumn = '';
            let sortDirection = '';

            if (tableState.activeColumn > -1) {
              sortColumn = mapPropName(tableState.sortOrder.name);
              sortDirection = tableState.sortOrder.direction;
              options.eventHandlers.updateTableSort(sortColumn, sortDirection);
            }
            break;
        }
      },
    },
  };
};
